var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{staticClass:"beereaders-chip",attrs:{"rounded":"lg","flat":"","color":"deep-purple lighten-5 pa-3 px-6"}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }